<template>
  <user-scope-selector
    ref="selector"
    tip="选择企业"
    class="company-selector"
    :value="localValue"
    @input="emitVal"
    :show-user-tab="false"
    :show-department-tab="false"
    :multiple="multiple"
    :disabled="disabled"
    :clearable="clearable"
    :additional-tabs="companyAdditionalTabs"
  ></user-scope-selector>
</template>

<script>
import UserScopeSelector from "@/components/UIComponents/UserScopeSelector"
import { getAllConnectedCompany } from "@/api/connect"

export default {
  name: "company-selector",
  components: { UserScopeSelector },
  props: {
    value: Array,
    disabled: Boolean,
    clearable: Boolean,
    multiple: Boolean,
    scope: {
      type: Array,
      default: () => [
        {
          type: "company",
          value: "1" // 代表全部
        }
        // {
        //   type: "company",
        //   value: 公司ID
        // },
        // {
        //   type: "companyType",
        //   value: 企业互联类型ID
        // },
      ]
    }
  },
  watch: {
    localValue: {
      handler(newVal, oldVal) {
        if (this._.isEqual(newVal, oldVal)) return
        this.initPromise.then(() => {
          this.$emit(
            "select",
            this.localValue.map(obj => this.companyMap[obj.value])
          )
        })
      }
    }
  },
  computed: {
    localValue() {
      return (this.value || []).map(id => ({
        type: "company",
        value: id
      }))
    },
    companyAdditionalTabs() {
      return [
        {
          label: "企业",
          value: "company",
          options: (this.connectedCompaniesScoped || []).map(({ id, name }) => ({ id, name }))
        }
      ]
    },
    connectedCompaniesScoped() {
      let scope = this.scope || []
      if (scope.length === 0 || scope.find(t => t.type === "company" && t.value === "1"))
        return this.companies
      return (this.companies || []).filter(company => {
        if (scope.find(t => t.type === "company" && t.value === company.id)) return true
        return scope.find(t => t.type === "companyType" && company.typeIds.includes(t.value))
      })
    },
    companyMap() {
      return this._.keyBy(this.connectedCompaniesScoped, "id")
    }
  },
  data() {
    return {
      companies: [],
      initPromise: null
    }
  },
  created() {
    this.initPromise = getAllConnectedCompany().then(companies => (this.companies = companies))
  },
  methods: {
    emitVal(val) {
      this.$emit(
        "input",
        (val || []).map(obj => obj.value)
      )

      // emit change
      this.$emit(
        "change",
        val.map(obj => this.companyMap[obj.value])
      )
    },
    focus() {
      this.$refs.selector.focus()
    }
  }
}
</script>

<style scoped></style>
